import { useState } from "react";

export default function InboxCanvasHook() {
    const [status, setStatus] = useState(false);
    const [data, setData] = useState(null);
    const open = () => { setStatus(true) };
    const close = () => setStatus(false);

    return {
        status: status,
        data: data,
        setData: setData,
        func: {
            open,
            close
        },
    };
}